/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import './src/constants/global.css';
import './src/constants/theme.css';

import React from 'react';
import {MDXProvider} from '@mdx-js/react';
import {CustomMDXProvider} from './src/components/MDXProvider';
import {
  getConsent,
  loadAnalytics,
  privacySignalOn,
  removeTrackingCookies,
  trackPageView,
} from './src/helpers/consent.helper';

// Google Analytics runs only with the visitor's consent and no GPC / Do Not Track
// signal. Otherwise analytics cookies left by earlier visits are deleted.
export const onClientEntry = () => {
  if (getConsent() === 'accepted' && !privacySignalOn()) {
    loadAnalytics();
  } else {
    removeTrackingCookies();
  }
};

export const onRouteUpdate = ({location}) => {
  trackPageView(location);
};

export const wrapRootElement = ({element}) => {
  return <CustomMDXProvider>{element}</CustomMDXProvider>;
};
